import React, { useState } from "react";
import { Order } from "../../interfaces/order";
import { uploadClientResponse } from "../../services/orderService";

interface UploadClientResponseProps {
  order: Order;
  onClose: (message?: string) => void;
}

const UploadClientResponse: React.FC<UploadClientResponseProps> = ({
  order,
  onClose,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [file, setFile] = useState<File | null>(null);

  const handleUploadResponse = async () => {
    if (!file) return;

    try {
      setLoadingSpinner(true);
      await uploadClientResponse(order, file);
      onClose();
    } catch (error) {
      console.error("Error handling file upload:", error);
      setErrorMessage("Error uploading additional form.");
    } finally {
      setLoadingSpinner(false);
    }
  };

  const handleGrabForm = async () => {
    try {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "image/*,.pdf";
      fileInput.click();
      fileInput.onchange = async (event: any) => {
        const file = event.target.files[0];
        if (!file) return;
        setFile(file);
      };
    } catch (error) {
      console.error("Error handling file upload:", error);
    } finally {
      setLoadingSpinner(false);
    }
  };

  return (
    <>
      <div className="background-mask" onClick={() => onClose()}></div>
      <div className="filter-popup">
        <div className="close-button-container">
          <button className="close-button" onClick={() => onClose()}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="filter-header">
          <h2>Upload Response</h2>
          <div>
            Please name the file as <b>Transfer/Client/Candidate/MMYY</b> to
            avoid overwriting a file with the same name.
          </div>
        </div>
        <br></br>
        <div className="dialog-container">
          <div className="action-buttons">
            <button className="smbtn btn-grey" onClick={() => handleGrabForm()}>
              Upload Client Response
            </button>
            {file && (
              <a
                href={URL.createObjectURL(file)}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Response
                <i className="btn-icon bi bi-box-arrow-up-right"></i>
              </a>
            )}
          </div>

          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </div>
        <div className="filter-actions">
          <button
            className={`smbtn btn-green ${!file ? "disabled" : ""}`}
            onClick={handleUploadResponse}
            disabled={!file}
          >
            Save to Client
          </button>
        </div>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>
      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </>
  );
};

export default UploadClientResponse;
